import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    error: null
}
/**
 * 
 * ~~ = ignore
 * ~_~ = delete/set to default value
 */
const PLATFORM = '../../WsWebServicePlatform/'
const WELLSUITE = '../../WsWebServiceWellSuite/';
// Participant/Misc/Types/Get/{AuthToken}/	
// Participant/Misc/Type/Update/{AuthToken}/{ParticipantRaceGuid}/{RaceName}/{RaceDescription}/	
// Participant/Misc/Type/Delete/{AuthToken}/{ParticipantRaceGuid}/	
// Participant/Misc/Type/Create/{AuthToken}/{RaceName}/{RaceDescription}/	
export const fetchPrivacyPolicy = createAsyncThunk('privacypolicy/get', async (incomingVariable, thunkAPI) => {
    
    try {
        const response = await axios.get(WELLSUITE + "GetViewInstancePublic/" + incomingVariable.GroupGuid+"/"+incomingVariable.LanguageId + "/508280B5-EA6F-432D-9CB6-B7E4B1CEF802"+'/')
        const data = await response.data.Success ? response.data : []

        return data
    } catch (err) {
    
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

const privacyPolicySlice = createSlice({
    name: 'privacyPolicy',
    initialState,
    reducers: {
        privacypolicyClear(state, action) {
            state.entities = initialState.entities
            state.status = "idle"
        }
    },
    extraReducers(builder) {
        builder
            //
            .addCase(fetchPrivacyPolicy.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchPrivacyPolicy.fulfilled, (state, action) => {
                state.status = 'success'
                state.entities = action.payload.Info[0].ViewInstanceData[0]
            })
            .addCase(fetchPrivacyPolicy.rejected, (state, action) => {
                state.error = action.error.message
                
            })    
    }
})


export default privacyPolicySlice.reducer
export const { privacypolicyClear } = privacyPolicySlice.actions

export const selectTCEntities = (state) => state.privacypolicy.entities
export const selectTCStatus = (state) => state.privacypolicy.status
export const selectTCError = (state) => state.privacypolicy.error